
























import { defineComponent, PropType, ref, watch } from '@vue/composition-api'
import { confirmCarBooking } from '~/api/RentalCar'
import CreateDialog from '~/components/CreateDialog.vue'
import IconButton from '~/components/IconButton.vue'
import { VueForm } from '~/utils/interfaces'
import { CarBooking } from '~/utils/interfaces/rentalCar'
import vRules from '~/utils/vRules'
export default defineComponent({
  components: {
    IconButton,
    CreateDialog,
  },
  props: {
    item: {
      type: Object as PropType<CarBooking>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const model = ref(false)
    const loading = ref(false)
    const crud = ref({ voucher: null as null | File })
    const form = ref<VueForm>()

    watch(model, v => {
      if (!v) form.value?.reset()
    })

    const onSuccess = async () => {
      if (!form.value?.validate()) return
      loading.value = true
      try {
        // @ts-ignore
        await confirmCarBooking(props.item.uuid, crud.value)
        emit('refresh')
        model.value = false
      } finally {
        loading.value = false
      }
    }

    return {
      model,
      vRules,
      loading,
      crud,
      form,
      onSuccess,
    }
  },
})
